// extracted by css-extract-rspack-plugin
export default {"reactNoVirtualizationWrapperLines":"CodeLinesNoVirtualization-module__reactNoVirtualizationWrapperLines__B1jzc"};